export const createEndId = (id: string) => `${id}-end`;
export const createStartId = (id: string) => `${id}-start`;
